<template lang="pug">
.container.grid-lg
  .columns.align-center
    .column
      filter-component
        div(slot="additionalButtons")
          .dropdown.dropdown-right
            a.btn.btn-sm.btn-link.dropdown-toggle.tooltip.tooltip-bottom(
              tabindex="0",
              data-tooltip="Novo serviço"
            )
              i.icon.icon-plus
            ul.menu
              li.menu-item
                router-link(
                  :to="{ name: 'app.osm.servicos.create' }",
                  v-acl:allowed.admin.ordem_servicos.create
                )
                  i.fa-fw.fa.fa-plus
                  |
                  | Nova
              li.menu-item
                router-link(
                  :to="{ name: 'app.osm.servicos.create.avulsa' }",
                  v-acl:allowed.admin.ordem_servicos.create
                )
                  i.fa-fw.fa.fa-plus-square
                  |
                  | Nova avulsa
              li.menu-item
                router-link(
                  :to="{ name: 'app.osm.servicos.create.massa' }",
                  v-acl:allowed.admin.ordem_servicos.create_massa
                )
                  i.fa-fw.fa.fa-clone
                  |
                  | Novos em massa
    .column.col-auto

  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      row(v-for="servico in list", :key="servico.id", :servico="servico")
    .my-2.text-right(v-if="pages > 1")
      btn-paginate(
        :page="page",
        :pages="pages",
        :count="count",
        @go-page="goPage",
        @prev-page="prevPage",
        @next-page="nextPage"
      )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"
import FilterComponent from "./Filter"
import Row from "./Row"

export default {
  vuex: { servicos: vuexDefaultMapping },
  components: { Row, FilterComponent },
  data() {
    return { q: {} }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
